import { GenericService } from "./Generic.service";

export class PersonCareLineService extends GenericService<string>{

    readonly URI: string = 'PessoaLinhaCuidado'

    constructor(){
        super()
        this.setUri(this.URI);
    }

    public async attachCareLineToPerson(body: any){
        return await super.postByResource(body, '')
    }

    public async detachCareLineFromPerson(body: any, pessoaId: string, linhaCuidadoId: string){
        return await super.deleteByResource(body, `Desvincular/${pessoaId}/${linhaCuidadoId}`)
    }
}